// Centralized translations for Suzel Holding public site
// Admin interface remains in French.

export const translations = {
  fr: {
    // Header / Nav
    "nav.home": "Maison",
    "nav.universes": "Univers",
    "nav.sneakers": "Sneakers",
    "nav.wigs": "Suzel Luxury Hair",
    "nav.about": "Histoire",
    "nav.contact": "Contact",
    "nav.printing": "Printing & IT",
    "nav.cart": "Panier",
    "nav.menu": "Menu",
    "nav.directContact": "Contact direct",

    // Hero
    "hero.location": "Suzel Holding · Goma, RDC",
    "hero.title1": "L'excellence",
    "hero.title2": "au pluriel.",
    "hero.subtitle": "Cinq univers d'exception réunis sous une seule signature. De la sneaker rare au pain artisanal, nous façonnons l'art de vivre congolais avec exigence.",
    "hero.cta1": "Explorer nos univers",
    "hero.cta2": "Boutique Sneakers",
    "hero.scroll": "Faites défiler",

    // Marquee
    "marquee.sneakers": "Sneakers édition limitée",
    "marquee.wigs": "Perruques 100% naturelles",
    "marquee.couture": "Haute couture sur-mesure",
    "marquee.epicerie": "Épicerie d'exception",
    "marquee.patisserie": "Pâtisserie artisanale",

    // Divisions section
    "divisions.overline": "House of Brands",
    "divisions.title1": "Cinq divisions,",
    "divisions.title2": "un même art.",
    "divisions.subtitle": "Chaque branche de Suzel Holding incarne une obsession : l'excellence dans son métier.",

    // Featured products
    "featured.overline": "Sélection · Boutique",
    "featured.title1": "Nouveautés",
    "featured.title2": "Sneakers",
    "featured.seeAll": "Voir toute la collection →",

    // Values
    "values.overline": "Notre signature",
    "values.title1": "Trois principes,",
    "values.title2": "une promesse.",
    "values.subtitle": "Suzel Holding est née d'une volonté simple : offrir le meilleur dans chaque catégorie où nous opérons. De la rue à la table, en passant par la silhouette.",
    "values.cta": "Notre histoire",
    "value1.title": "Excellence",
    "value1.desc": "Une exigence sans compromis sur la qualité, dans toutes nos divisions.",
    "value2.title": "Authenticité",
    "value2.desc": "Un savoir-faire enraciné à Goma, ouvert sur le meilleur du monde.",
    "value3.title": "Service",
    "value3.desc": "Une relation client à la hauteur de nos produits : attentive et durable.",

    // Home CTA
    "homeCta.overline": "Une question ?",
    "homeCta.title1": "Parlons de votre",
    "homeCta.title2": "projet.",
    "homeCta.subtitle": "Commande spéciale, partenariat, ou simple conseil — notre équipe vous répond.",
    "homeCta.button": "Nous écrire",

    // Footer
    "footer.title1": "L'excellence,",
    "footer.title2": "au pluriel.",
    "footer.desc": "Cinq univers réunis sous une même signature, à Goma, République Démocratique du Congo. Une promesse : la qualité sans compromis.",
    "footer.universes": "Univers",
    "footer.contact": "Contact",
    "footer.copyright": "© {year} Suzel Holding — Goma, RDC",

    // Cart
    "cart.title": "Votre panier",
    "cart.empty": "Votre panier est vide",
    "cart.emptyDesc": "Découvrez notre sélection en édition limitée.",
    "cart.explore": "Explorer la boutique",
    "cart.size": "Taille",
    "cart.subtotal": "Sous-total",
    "cart.disclaimer": "Le paiement en ligne sera bientôt disponible. Pour confirmer votre commande, contactez-nous via WhatsApp.",
    "cart.checkout": "Commander via WhatsApp",
    "cart.clear": "Vider le panier",
    "cart.items": "article",
    "cart.items_plural": "articles",
    "cart.whatsappPrefix": "Bonjour Suzel Holding, je souhaite finaliser ma commande:",

    // Divisions page
    "divisionsPage.overline": "Nos univers",
    "divisionsPage.title1": "Cinq divisions.",
    "divisionsPage.title2": "Une signature.",
    "divisionsPage.subtitle": "Découvrez chaque branche de la maison Suzel. Chaque univers est dirigé avec la même exigence : la qualité sans compromis.",
    "divisionsPage.cta": "Découvrir",

    // Collection page
    "collection.division": "Division",
    "collection.askAdvice": "Demander conseil",
    "collection.filterBrand": "Marque",
    "collection.filterCategory": "Catégorie",
    "collection.all": "Tous",
    "collection.reset": "Réinitialiser",
    "collection.sortNewest": "Nouveautés",
    "collection.sortPriceAsc": "Prix croissant",
    "collection.sortPriceDesc": "Prix décroissant",
    "collection.sortName": "A → Z",
    "collection.loading": "Chargement...",
    "collection.product": "produit",
    "collection.products": "produits",
    "collection.noProducts": "Aucun produit pour le moment",
    "collection.noProductsDesc": "Contactez-nous pour une commande personnalisée.",
    "collection.filters": "Filtres",
    "collection.apply": "Appliquer",
    "collection.onRequest": "Sur demande",
    "collection.limited": "Limited",
    "collection.new": "Nouveau",

    // Collection meta
    "cat.sneakers.title": "La collection",
    "cat.sneakers.accent": "Sneakers",
    "cat.sneakers.desc": "Édition limitée, lifestyle, running, collab. Chaque paire est sourcée et authentifiée.",
    "cat.sneakers.tagline": "Le style commence par les pieds.",
    "cat.sneakers.label": "Sneakers",
    "cat.wigs.title": "Suzel Luxury",
    "cat.wigs.accent": "Hair",
    "cat.wigs.desc": "Lace front, full lace, extensions — cheveux 100% naturels. Posés et entretenus par nos expertes.",
    "cat.wigs.tagline": "La beauté commence par les cheveux.",
    "cat.wigs.label": "Suzel Luxury Hair",
    "cat.couture.title": "Habillement",
    "cat.couture.accent": "sur-mesure",
    "cat.couture.desc": "Pièces uniques signées Suzel. Prêt-à-porter et sur-mesure. Prise de mesures sur rendez-vous.",
    "cat.couture.tagline": "L'élégance se taille sur mesure.",
    "cat.couture.label": "Habillement",
    "cat.epicerie.title": "Suzel Travel Agency",
    "cat.epicerie.accent": "& General Market",
    "cat.epicerie.desc": "Agence de voyage, vins, spiritueux, produits fins et essentiels du quotidien — sous un même toit.",
    "cat.epicerie.tagline": "L'évasion et l'essentiel, sous un même toit.",
    "cat.epicerie.label": "Travel & Market",
    "cat.patisserie.title": "Suzel",
    "cat.patisserie.accent": "Bakery",
    "cat.patisserie.desc": "Pain au levain, viennoiseries et créations sucrées, faits maison à Goma.",
    "cat.patisserie.tagline": "Le bonheur sort du four chaque matin.",
    "cat.patisserie.label": "Bakery",
    "cat.printing.title": "Suzel Printing &",
    "cat.printing.accent": "IT Hardware Store",
    "cat.printing.desc": "Imprimerie professionnelle, fournitures bureautiques, matériel informatique et accessoires high-tech.",
    "cat.printing.tagline": "L'innovation au service de votre bureau.",
    "cat.printing.label": "Printing & IT",

    // Product detail
    "product.back": "Retour à la collection",
    "product.onRequest": "Sur devis",
    "product.askQuote": "Demander un devis",
    "product.inStock": "en stock",
    "product.sizeEU": "Taille EU",
    "product.selectSize": "Sélectionnez une taille",
    "product.addToCart": "Ajouter au panier",
    "product.added": "Ajouté au panier",
    "product.story": "L'histoire",
    "product.authenticity": "Authenticité",
    "product.authenticityDesc": "Garantie 100% authentique, certificat fourni.",
    "product.delivery": "Livraison",
    "product.deliveryDesc": "Goma & RDC. International sur demande.",
    "product.limitedEdition": "Édition Limitée",
    "product.notFound": "Produit introuvable",
    "product.backToUniverses": "Retour aux univers",
    "product.whatsappQuote": "Bonjour, je suis intéressé(e) par : {name}. Pouvez-vous me faire un devis ?",

    // About page
    "about.overline": "Notre histoire",
    "about.title1": "Une vision,",
    "about.title2": "plusieurs métiers.",
    "about.subtitle": "Suzel Holding est née à Goma, en République Démocratique du Congo, d'une volonté simple : offrir le meilleur dans chaque catégorie où nous opérons.",
    "about.section2Overline": "Goma · RDC",
    "about.section2Title1": "Du local",
    "about.section2Title2": "à l'exceptionnel.",
    "about.section2P1": "De la sélection rigoureuse de sneakers en édition limitée aux perruques cheveux 100% naturels, en passant par la haute couture, l'épicerie d'exception et la pâtisserie artisanale, chaque division est dirigée avec la même exigence.",
    "about.section2P2": "Notre promesse : la qualité sans compromis, le service à la hauteur, et un savoir-faire authentiquement congolais ouvert sur le monde.",
    "about.section2Cta": "Voir nos divisions",
    "about.valuesOverline": "Nos valeurs",
    "about.valuesTitle1": "Trois principes,",
    "about.valuesTitle2": "une signature.",
    "about.value1Desc": "Une exigence sans compromis sur la qualité, dans toutes nos divisions. Chaque produit est choisi, testé, validé.",
    "about.value2Desc": "Un savoir-faire enraciné à Goma, ouvert sur le meilleur du monde. Le local rencontre l'international.",
    "about.value3Desc": "Une relation client à la hauteur de nos produits : attentive, personnalisée et durable.",
    "about.ctaTitle1": "Discuter avec",
    "about.ctaTitle2": "nous.",
    "about.ctaButton": "Nous contacter",

    // Contact page
    "contact.overline": "Contact",
    "contact.title1": "Parlons de votre",
    "contact.title2": "projet",
    "contact.subtitle": "Une question, une commande spéciale ou un partenariat ? Notre équipe vous répond.",
    "contact.address": "Adresse",
    "contact.addressLine1": "Av. Walikale, Entrée Modé,",
    "contact.addressLine2": "face à Jumbo Paint",
    "contact.addressLine3": "Goma, République Démocratique du Congo",
    "contact.phone": "Téléphone / WhatsApp",
    "contact.email": "Email",
    "contact.formName": "Nom complet",
    "contact.formEmail": "Email",
    "contact.formPhone": "Téléphone (optionnel)",
    "contact.formSubject": "Sujet",
    "contact.formMessage": "Votre message",
    "contact.formMessagePlaceholder": "Dites-nous tout...",
    "contact.formError": "Une erreur est survenue. Réessayez ou contactez-nous par WhatsApp.",
    "contact.formSuccess": "Message envoyé. Nous vous répondons rapidement.",
    "contact.formSubmit": "Envoyer le message",
    "contact.formSubmitting": "Envoi en cours",
  },
  en: {
    // Header / Nav
    "nav.home": "Home",
    "nav.universes": "Houses",
    "nav.sneakers": "Sneakers",
    "nav.wigs": "Suzel Luxury Hair",
    "nav.about": "Story",
    "nav.contact": "Contact",
    "nav.printing": "Printing & IT",
    "nav.menu": "Menu",
    "nav.directContact": "Direct contact",

    // Hero
    "hero.location": "Suzel Holding · Goma, DRC",
    "hero.title1": "Excellence",
    "hero.title2": "in the plural.",
    "hero.subtitle": "Five worlds of excellence, one signature. From the rarest sneaker to artisan bread, we craft Congolese living with uncompromising standards.",
    "hero.cta1": "Discover our houses",
    "hero.cta2": "Sneaker Boutique",
    "hero.scroll": "Scroll down",

    // Marquee
    "marquee.sneakers": "Limited edition sneakers",
    "marquee.wigs": "100% natural wigs",
    "marquee.couture": "Made-to-measure couture",
    "marquee.epicerie": "Fine grocery",
    "marquee.patisserie": "Artisan pastry",

    // Divisions section
    "divisions.overline": "House of Brands",
    "divisions.title1": "Five houses,",
    "divisions.title2": "one craft.",
    "divisions.subtitle": "Each branch of Suzel Holding embodies one obsession: excellence in its craft.",

    // Featured products
    "featured.overline": "Selection · Boutique",
    "featured.title1": "New",
    "featured.title2": "Sneakers",
    "featured.seeAll": "See the full collection →",

    // Values
    "values.overline": "Our signature",
    "values.title1": "Three principles,",
    "values.title2": "one promise.",
    "values.subtitle": "Suzel Holding was born of one simple ambition: to offer the best in every category we work in. From the street to the table, by way of the silhouette.",
    "values.cta": "Our story",
    "value1.title": "Excellence",
    "value1.desc": "An uncompromising demand for quality, across every house.",
    "value2.title": "Authenticity",
    "value2.desc": "A craftsmanship rooted in Goma, open to the very best of the world.",
    "value3.title": "Service",
    "value3.desc": "A client relationship worthy of our products: attentive and lasting.",

    // Home CTA
    "homeCta.overline": "A question?",
    "homeCta.title1": "Let's talk about your",
    "homeCta.title2": "project.",
    "homeCta.subtitle": "Special order, partnership, or simply advice — our team is here.",
    "homeCta.button": "Get in touch",

    // Footer
    "footer.title1": "Excellence,",
    "footer.title2": "in the plural.",
    "footer.desc": "Five worlds under one signature, in Goma, Democratic Republic of Congo. One promise: uncompromising quality.",
    "footer.universes": "Houses",
    "footer.contact": "Contact",
    "footer.copyright": "© {year} Suzel Holding — Goma, DRC",

    // Cart
    "cart.title": "Your cart",
    "cart.empty": "Your cart is empty",
    "cart.emptyDesc": "Discover our limited edition selection.",
    "cart.explore": "Explore the boutique",
    "cart.size": "Size",
    "cart.subtotal": "Subtotal",
    "cart.disclaimer": "Online payment is coming soon. To confirm your order, please contact us on WhatsApp.",
    "cart.checkout": "Order via WhatsApp",
    "cart.clear": "Clear cart",
    "cart.items": "item",
    "cart.items_plural": "items",
    "cart.whatsappPrefix": "Hello Suzel Holding, I'd like to finalize my order:",

    // Divisions page
    "divisionsPage.overline": "Our houses",
    "divisionsPage.title1": "Five houses.",
    "divisionsPage.title2": "One signature.",
    "divisionsPage.subtitle": "Discover every branch of the House of Suzel. Each one is led with the same standard: uncompromising quality.",
    "divisionsPage.cta": "Discover",

    // Collection page
    "collection.division": "Division",
    "collection.askAdvice": "Ask for advice",
    "collection.filterBrand": "Brand",
    "collection.filterCategory": "Category",
    "collection.all": "All",
    "collection.reset": "Reset",
    "collection.sortNewest": "Newest",
    "collection.sortPriceAsc": "Price ascending",
    "collection.sortPriceDesc": "Price descending",
    "collection.sortName": "A → Z",
    "collection.loading": "Loading...",
    "collection.product": "product",
    "collection.products": "products",
    "collection.noProducts": "No product yet",
    "collection.noProductsDesc": "Contact us for a custom order.",
    "collection.filters": "Filters",
    "collection.apply": "Apply",
    "collection.onRequest": "On request",
    "collection.limited": "Limited",
    "collection.new": "New",

    // Collection meta
    "cat.sneakers.title": "The collection",
    "cat.sneakers.accent": "Sneakers",
    "cat.sneakers.desc": "Limited edition, lifestyle, running, collabs. Every pair sourced and authenticated.",
    "cat.sneakers.tagline": "Style starts at your feet.",
    "cat.sneakers.label": "Sneakers",
    "cat.wigs.title": "Suzel Luxury",
    "cat.wigs.accent": "Hair",
    "cat.wigs.desc": "Lace front, full lace, extensions — 100% natural hair. Installed and maintained by our experts.",
    "cat.wigs.tagline": "Beauty starts with the hair.",
    "cat.wigs.label": "Suzel Luxury Hair",
    "cat.couture.title": "Apparel",
    "cat.couture.accent": "tailored",
    "cat.couture.desc": "One-of-a-kind pieces by Suzel. Ready-to-wear and made-to-measure. Fittings by appointment.",
    "cat.couture.tagline": "Elegance is tailored to fit.",
    "cat.couture.label": "Apparel",
    "cat.epicerie.title": "Suzel Travel Agency",
    "cat.epicerie.accent": "& General Market",
    "cat.epicerie.desc": "Travel agency, wines, spirits, fine produce and daily essentials — all under one roof.",
    "cat.epicerie.tagline": "Escape and essentials, under one roof.",
    "cat.epicerie.label": "Travel & Market",
    "cat.patisserie.title": "Suzel",
    "cat.patisserie.accent": "Bakery",
    "cat.patisserie.desc": "Sourdough bread, viennoiseries and sweet creations, made fresh every morning in Goma.",
    "cat.patisserie.tagline": "Happiness comes out of the oven every morning.",
    "cat.patisserie.label": "Bakery",
    "cat.printing.title": "Suzel Printing &",
    "cat.printing.accent": "IT Hardware Store",
    "cat.printing.desc": "Professional printing, office supplies, IT hardware and high-tech accessories.",
    "cat.printing.tagline": "Innovation, at the service of your office.",
    "cat.printing.label": "Printing & IT",

    // Product detail
    "product.back": "Back to collection",
    "product.onRequest": "On request",
    "product.askQuote": "Request a quote",
    "product.inStock": "in stock",
    "product.sizeEU": "Size EU",
    "product.selectSize": "Please select a size",
    "product.addToCart": "Add to cart",
    "product.added": "Added to cart",
    "product.story": "The story",
    "product.authenticity": "Authenticity",
    "product.authenticityDesc": "100% authentic guarantee, certificate included.",
    "product.delivery": "Shipping",
    "product.deliveryDesc": "Goma & DRC. International on request.",
    "product.limitedEdition": "Limited Edition",
    "product.notFound": "Product not found",
    "product.backToUniverses": "Back to houses",
    "product.whatsappQuote": "Hello, I'm interested in: {name}. Could I have a quote please?",

    // About page
    "about.overline": "Our story",
    "about.title1": "One vision,",
    "about.title2": "many crafts.",
    "about.subtitle": "Suzel Holding was born in Goma, Democratic Republic of Congo, from one simple intent: to offer the best in every category we work in.",
    "about.section2Overline": "Goma · DRC",
    "about.section2Title1": "From local",
    "about.section2Title2": "to exceptional.",
    "about.section2P1": "From the rigorous curation of limited edition sneakers to 100% natural hair wigs, through haute couture, fine grocery and artisan pastry, every house is led with the same standard.",
    "about.section2P2": "Our promise: uncompromising quality, service worthy of our products, and authentically Congolese craftsmanship open to the world.",
    "about.section2Cta": "See our houses",
    "about.valuesOverline": "Our values",
    "about.valuesTitle1": "Three principles,",
    "about.valuesTitle2": "one signature.",
    "about.value1Desc": "An uncompromising demand for quality, across every house. Every product is chosen, tested, validated.",
    "about.value2Desc": "A craftsmanship rooted in Goma, open to the very best of the world. Local meets international.",
    "about.value3Desc": "A client relationship worthy of our products: attentive, personalized and lasting.",
    "about.ctaTitle1": "Talk to",
    "about.ctaTitle2": "us.",
    "about.ctaButton": "Get in touch",

    // Contact page
    "contact.overline": "Contact",
    "contact.title1": "Let's talk about your",
    "contact.title2": "project",
    "contact.subtitle": "A question, a special order or a partnership? Our team is here.",
    "contact.address": "Address",
    "contact.addressLine1": "Av. Walikale, Entrée Modé,",
    "contact.addressLine2": "across from Jumbo Paint",
    "contact.addressLine3": "Goma, Democratic Republic of Congo",
    "contact.phone": "Phone / WhatsApp",
    "contact.email": "Email",
    "contact.formName": "Full name",
    "contact.formEmail": "Email",
    "contact.formPhone": "Phone (optional)",
    "contact.formSubject": "Subject",
    "contact.formMessage": "Your message",
    "contact.formMessagePlaceholder": "Tell us everything...",
    "contact.formError": "An error occurred. Please try again or contact us on WhatsApp.",
    "contact.formSuccess": "Message sent. We'll get back to you shortly.",
    "contact.formSubmit": "Send message",
    "contact.formSubmitting": "Sending",
  },
};
